import {combineReducers} from "redux";
import create from './create';
import deleteSector from './delete';
import deleteSelection from "./deleteSelection";
import list from "./list";
import update from './update';

export default combineReducers({ create, deleteSector, deleteSelection, list, update });
